'use client';
import { useEffect, useState } from 'react';
const DEFAULT_OFFSET = 300;
export const useObserverElementById = ({
  ids,
  offset = DEFAULT_OFFSET,
}: {
  ids: string[];
  offset?: number;
}) => {
  const [activeId, setActiveId] = useState<string | undefined>(undefined);
  useEffect(() => {
    const height = window.innerHeight;
    const options = {
      root: window.document,
      rootMargin: `-${offset}px 0px -${height - offset - 10}px 0px`,
      threshold: 0,
    };

    const handler = (entries: IntersectionObserverEntry[]) => {
      for (const entry of entries) {
        setActiveId((currentActiveId) => {
          if (entry.isIntersecting) {
            return entry.target.id;
          }
          if (currentActiveId === entry.target.id) {
            return undefined;
          }
          return currentActiveId;
        });
      }
    };
    const observer = new IntersectionObserver(handler, options);

    for (const id of ids) {
      const section = document.querySelector(`#${id}`);
      if (section) {
        observer.observe(section);
      }
    }
    return () => {
      observer.disconnect();
    };
  }, [ids]);

  return activeId;
};
